export { default } from "./tabScriptsContainer";
